export default __webpack_public_path__ + "static/media/activity-washing.21b21acd.svg";